import { injectIntl } from "react-intl";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createSelector } from 'reselect';
import PricerProgressComponent from './PricerProgressPage';

import { pricerProgressLanding, resetPage, set } from '../../../store/actions/pages';
import { BooleanEquators, integerEquators, StringEquators } from '../../../store/constants/pages';
import { createCurrencyDataField, createNumberDataField, createStringDataField } from '../../../util/format';

import { getByName, reset } from '../../../store/actions/search';
import { selectSessionRole } from '../../../store/selectors/session';
import { selectSelectedClientName } from '../../../store/selectors/clients';

const patientTypes = [
  { label: 'INPATIENT', value: 'INPATIENT' },
  { label: 'OUTPATIENT', value: 'OUTPATIENT' }
];

const selectFields = createSelector(
    () => [
        createStringDataField('payerName', 'Payer Name', { sortable: true, equators: StringEquators, whiteSpace: 'break-spaces' }),
        createStringDataField('pxCode', 'CPT Codes', { sortable: true, equators: StringEquators }),
        createStringDataField('revCode', 'Rev Codes', { sortable: true, equators: StringEquators }),
        createStringDataField('payeeNPI', 'Payee NPI', { sortable: true, equators: StringEquators }),
        createCurrencyDataField('percentile10th', '10th Percentile', { sortable: true, equators: integerEquators }),
        createCurrencyDataField('percentile50th', '50th Percentile', { sortable: true, equators: integerEquators }),
        createCurrencyDataField('percentile90th', '90th Percentile', { sortable: true, equators: integerEquators }),
        createNumberDataField('totalClaims', 'Total Claims', { sortable: true, equators: integerEquators }),
        createStringDataField('visitType', 'Visit Type',
             { sortable: true,
               equators: BooleanEquators,
               whiteSpace: 'break-spaces',
               isStrictDropdown: true,
               dropdownValues: patientTypes
             }),
    ]
);

const selectData = createSelector(
    (state) => state.pages['pricer-progress-landing'].list,
    (data) => data
);


export const PricerProgressPage = connect(
    () => {
        return (state: any, props) => ({
            pricerProgressListPending: state.payers.list.pending,
            pricerProgressData: selectData(state),
            pricerProgressFields: selectFields(state as never),
            userRole: selectSessionRole(state),
            clientName: selectSelectedClientName(state),
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            pricerProgressLanding: pricerProgressLanding,
            searchGetByName: getByName,
            searchReset: reset,
            resetPagedTable: resetPage,
            setList: (value) => set('pricer-progress-landing', 'list', value),
        }, dispatch)
    })
)(injectIntl(PricerProgressComponent));